import { render, staticRenderFns } from "./prognNoHeating.vue?vue&type=template&id=3108a394"
import script from "./prognNoHeating.vue?vue&type=script&lang=js"
export * from "./prognNoHeating.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports